import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'id',
      label: i18n.t('common_words.id'),
      minWidth: 80,
      sortable: true,
    },
    {
      prop: 'fecha',
      label: i18n.t('common_words.date'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'hora',
      label: i18n.t('common_words.hour'),
      minWidth: 120,
      sortable: true,
    },
    /*{
      prop: "code_finca",
      label: "Código de Finca",
      minWidth: 120
    },
    {
      prop: "peso_bruto",
      label: "Peso Neto (Kg)",
      minWidth: 120
    },
    {
      prop: "edad",
      label: "edad",
      minWidth: 120
    },
    {
      prop: "cinta",
      label: "cinta",
      minWidth: 120
    },
    {
      prop: "cuadrilla",
      label: "cuadrilla",
      minWidth: 120
    },
    {
      prop: "lote",
      label: "lote",
      minWidth: 120
    },
    {
      prop: "tipo_recusado_id",
      label: "motivo recucaso",
      minWidth: 120
    },
    {
      prop: "numero_de_manos",
      label: "# manos",
      minWidth: 120
    },
    {
      prop: "calibracion_segunda_mano",
      label: "calibracion segunda mano",
      minWidth: 120
    },
    {
      prop: "calibracion_ultimo_mano",
      label: "calibracion ultima mano",
      minWidth: 120
    },
    {
      prop: "largo_segunda_mano",
      label: "largo segunda mano",
      minWidth: 120
    },
    {
      prop: "largo_ultima_mano",
      label: "largo ultima mano",
      minWidth: 120
    },*/
  ];

  return { Table };
};

export default configTable;
